import ReCAPTCHA from 'react-google-recaptcha';

const CaptchaCheckbox = ({ sitekey = null, onChange }) => {
  if (!sitekey) {
    throw new Error('Captcha error. Please contact admin')
  }

  return (
    <div className="mt-4 d-flex align-item-center justify-content-center">
      <ReCAPTCHA
        onError={() => {
          alert('error')
        }}
        sitekey={sitekey}
        onChange={onChange}
        style={{
          width: '100%',
        }}
      />
    </div>
  );
};

export default CaptchaCheckbox;
